const uuid_v4       = require('uuid').v4
let plupload 	= {}
try { plupload 		= require('plupload') } catch (error){}

const appConfig		= require('../../../../../lib/config').getConfig()
const utils 		= require('../../../../../lib/utils')

module.exports = {
	config: {
		mode: 		'image',
		secureRoute: '/~/upload/preparedImage',
		showTaggedUpload: false,
		startOnFilesAdded: true,
		autoOpenUploadDialog: false,
		isInstantUploader: false,
		isReusable: true,
		pluploaderConfig: {
			runtimes:               'html5,flash,silverlight,html4',
			// browse_button:          'upload', // will be set by attach-trigger
			container:              undefined, // ... or DOM Element itself
			chunk_size:             '200kb',
			// unique_names:           true,     //-> we want the original filename -> don't use it
			// max_retries > 0 messes up the relogin error handling on session timeouts!
			max_retries:            0,
			flash_swf_url:          '/webpack/js/Moxie.swf',
			silverlight_xap_url:    '/webpack/js/Moxie.xap',

			headers: {},

			multipart_params: {
				fileID: 'replaceThis',
				categories: {},
				categoriesByRoute: [],
				permissions: null,
			},

			filters: {
				// prevent_duplicates : true,
				max_file_size : '50mb',
				mime_types: [
					{title : "Image files", extensions : "jpg,jpeg,gif,png,svg,webp"}
				]
			},

			init: {
				PostInit: function(up){
					// console.log('PostInit', arguments)
					// document.getElementById('filelist').innerHTML = ''
					//
					// document.getElementById('uploadfiles').onclick = function() {
					// 	uploader.start()
					// 	return false
					// }
				},

				FilesAdded: function(up, files) {
					// console.log('FilesAdded', arguments)

					up.component.$.find('.progress').addClass('inProgress')
					up.component.$.find('button.upload').addClass('filesChosen')

					up.component.model.uploadedMediaIDs = []
					up.component.model.uploadedMedia = []
					up.settings.multipart_params.categories = JSON.stringify(up.component.model.mediaCategories || {})
					up.settings.multipart_params.categoriesByRoute = JSON.stringify(up.component.model.mediaCategoriesByRoute || [])
					up.settings.multipart_params.permissions = JSON.stringify(up.component.model.permissions || null)
					up.settings.multipart_params.isReusable = JSON.stringify(up.component.model.isReusable)

					if(up.component.config.startOnFilesAdded){
						up.start()
					}

					// plupload.each(files, function(file) {
					// 	document.getElementById('filelist').innerHTML += '<div id="' + file.id + '">' + file.name + ' (' + plupload.formatSize(file.size) + ') <b></b></div>'
					// })
				},

				FilesRemoved: function(up, files) {
					if((up.files || []).length < 1){
						up.component.$.find('.progress').removeClass('inProgress')
						up.component.$.find('button.upload').removeClass('filesChosen')
					}
				},

				BeforeUpload: function(up, file){
					// set file id for the actual file
					up.settings.multipart_params.fileID = uuid_v4()
					// console.log('BeforeUpload', arguments)
				},

				BeforeChunkUpload: function(up, file, post){
					up.component.beforeChunkUpload(file, post)
				},

				UploadProgress: function(up, file) {
					// console.log('UploadProgress', arguments)

					const $progress = up.component.$.find('.progress')
					const $progressBar = $progress.find('.background')
					const $progressContent = $progress.find('.content')
					$progressBar.width(up.total.percent + '%')
					$progressContent.html(up.total.percent + '%')
					// document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>"
				},

				ChunkUploaded: function(up, file, result){
					up.component.chunkUploaded(file, result)
				},

				FileUploaded: function(up, file, result){
					// console.log('FileUploaded', arguments)
					if(result.status === 200 && result.response){
						result.response = JSON.parse(result.response)
						up.component.model.lastResponse = result.response
						const mediaAttributes = (result.response || {}).data || {}

						if(mediaAttributes.mediaID){
							up.component.model.uploadedMediaIDs.push(mediaAttributes.mediaID)
							up.component.model.uploadedMedia.push(mediaAttributes)
						}
					}
				},

				UploadComplete: function(up, files){
					// console.log('UploadComplete', arguments)

					const $progress = up.component.$.find('.progress')
					const $progressBar = $progress.find('.background')
					$progress.removeClass('inProgress')
					$progressBar.width('0')

					if(typeof(up.component.uploadComplete) === 'function'){
						up.component.uploadComplete(files)
					}

					delete up.component.model.mediaCategories
					delete up.component.model.uploadedMediaIDs
					delete up.component.model.uploadedMedia
					delete up.settings.multipart_params.categories
				},

				Error: function(up, error) {
					let errorCode
					switch(error.code){
						case plupload.HTTP_ERROR:                   errorCode = 'http'; break;
						case plupload.IO_ERROR:                     errorCode = 'io'; break;
						case plupload.SECURITY_ERROR:               errorCode = 'security'; break;
						case plupload.INIT_ERROR:                   errorCode = 'init'; break;
						case plupload.FILE_SIZE_ERROR:              errorCode = 'file-size'; break;
						case plupload.FILE_EXTENSION_ERROR:         errorCode = 'file-extension'; break;
						case plupload.FILE_DUPLICATE_ERROR:         errorCode = 'file-duplicate'; break;
						case plupload.IMAGE_FORMAT_ERROR:           errorCode = 'image-format'; break;
						case plupload.MEMORY_ERROR:                 errorCode = 'memory'; break;
						case plupload.IMAGE_DIMENSIONS_ERROR:       errorCode = 'image-dimensions'; break;
						case plupload.GENERIC_ERROR:
						default:                            		errorCode = 'generic'; break;
					}

					// stop and reset uploader on error to prevent multi error handling
					up.stop()
					up.component.refresh()

					if(error.status === 401){
						return up.component.performAndStoreAction(
							undefined,
							up.component.prepareAction(appConfig.credentials.reLoginAction, undefined, {
								loginForm: {}
							}, {
								skipRollback:  true,
								statusControllerLoadingMessage: '',
								statusControllerSavingMessage:  '',
							})
						)
					}

					up.component.performAction(up.component.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:pluploader.' + errorCode,
							variables: {
								max_file_size: String(up.component.config.pluploaderConfig.filters.max_file_size).toUpperCase()
							},
						}
					}))
				}
			}
		},
		showResultsContainer: false, // if an extension of this component wants to show some result summary this container may be helpful
	},
	model: {
		errors: [],
		mediaCategories: [],
		mediaCategoriesByRoute: [],
		uploadedMediaIDs: [],
		uploadedMedia: [],
		permissions: null
	},

	events: {
		taggedUpload: {
			type: 'click',
			selector: '.taggedUpload',
			action: function(event){
				event.preventDefault()
				event.stopImmediatePropagation()

				const self = event.data.component
				self.model.mediaCategories = []
				self.closest('base_modal_modal', function(modal){
					modal.find('base_form_fields_tag-picker-button', function(tagPickerButton){
						tagPickerButton.open(undefined, options => {
							const categories = ((options || {}).decisionOptions || {}).dirtyAssignedTags || {}
							self.model.mediaCategories = []
							for(const i in categories){
								self.model.mediaCategories.push({
									categoryID: 	categories[i].categoryID,
									categoryDataID: categories[i].categoryDataID,
									enabled: 		categories[i].enabled,
								})
							}
							self.$.find('.untaggedUpload').click()
						})
					})
				})
			}
		}
	},

	methods: {
		uploadComplete: function(){
			if((this.model.uploadedMediaIDs || []).length > 0){
				if(this.config.isInstantUploader){
					this.triggerClosest('onDecision', {
						// mediaIDs: this.model.uploadedMediaIDs,
						decisionType: 'submit',
						decisionComponent: this,
						// decisionOptions: 			decisionOptions,
						// decisionTriggerComponent: 	decisionTriggerComponent,
						mediaList: this.model.uploadedMedia,
					})
				} else {
					this.triggerClosest('updateMediaTagsInList', { mediaIDs: this.model.uploadedMediaIDs })
				}
			}
		},

		// OVERWRITE THIS IF NECESSARY
		beforeChunkUpload: function(file, post){},
		chunkUploaded: function(file, result){},
	},

	hooks: {
		async attach($element, options){
			if(!options.refresh){
				this.model.fieldConfig = this.getResourceRegisterContent('fieldConfig') || {}
				this.model.owner = this.getResourceRegisterContent('owner') || utils.permissions.getOwner(this.getStorage()) || null
				this.model.managementConfig = this.model.fieldConfig.managementConfig || {}
				this.model.uploaderConfig = this.model.managementConfig.uploaderConfig || {}
				this.model.basePermissions = this.model.managementConfig.permissions || utils.permissions.getDefault(this.getStorage())
				this.model.isReusable = !this.config.isInstantUploader
				if(this.model.managementConfig.isReusable !== undefined){
					this.model.isReusable = this.model.managementConfig.isReusable
				}

				if(this.model.basePermissions || this.model.owner){
					this.model.permissions = {
						...(this.model.basePermissions || {}),
						owner: {
							...(this.model.owner || {})
						}
					}
				}
			}

			if(!this.model.owner){
				const onDecisionPromise = utils.promise.newCustom(this)
				await this.performMessage({
					onDecisionPromise,
					messageDisplay: {
						message: 'error:pluploader.missingOwner'
					}
				})
				await onDecisionPromise
				this.closest('base_modal_modal', modal => {
					modal.destroy()
				})
				return
			}

			// TODO: MARK: SPECIAL ROUTES + check /LTR => /~/LTR changes after nginx proxy update
			this.config.pluploaderConfig.url = `/LTR${this.config.secureRoute || ''}`
			this.config.pluploaderConfig.headers['fec_secure_route_hash'] = this.config.secureRouteHash || ''
			this.config.pluploaderConfig.container = $element.find('.uploads')[0]
			this.config.pluploaderConfig.browse_button = 'upload_' + this.config.mode

			// sanitize multi select values
			const managementConfig = this.model.managementConfig
			let maxNrOfElements = Number.MAX_SAFE_INTEGER
			if(managementConfig.multiSelect === false || managementConfig.maxNrOfElements <= 1){
				maxNrOfElements = 1
			}
			else if(managementConfig.maxNrOfElements > 1){
				maxNrOfElements = managementConfig.maxNrOfElements
			}
			if(maxNrOfElements <= 1){
				managementConfig.multiSelect = false
				this.config.pluploaderConfig.multi_selection = false
			}

			const atomConfigFilters = this.model.uploaderConfig.filters
			if(atomConfigFilters){
				if(atomConfigFilters.mime_types) this.config.pluploaderConfig.filters.mime_types = atomConfigFilters.mime_types;
				if(atomConfigFilters.max_file_size) this.config.pluploaderConfig.filters.max_file_size = atomConfigFilters.max_file_size;
			}

			if(utils.collectionSize(this.model.uploaderConfig.categoriesByRoute) > 0){
				this.model.mediaCategoriesByRoute = utils.collectionValues(this.model.uploaderConfig.categoriesByRoute)
			}

			this.model._uploader = new plupload.Uploader(this.config.pluploaderConfig)
			this.model._uploader.init()
			this.model._uploader.component = this
		},

		modalAttached: function($element, options){
			if(this.config.autoOpenUploadDialog){
				this.$.find(`#${this.config.pluploaderConfig.browse_button}`).click()
			}
		},

		/**
		 * if this is used as part of a form the reset call of the parent form may reset the chosen files here.
		 * @param $element
		 * @param options
		 */
		resetDirties: function($element, options){
			if(this.model._uploader){
				this.model._uploader.splice()
			}
		}
	}
}